import { setDropDown, setModal } from "../actions/modal.js";

import ChainMenu from "../../kjedeweb/components/ChainMenu.jsx";
import DominosMenu from "../../dominosweb/components/DominosMenu.jsx";
import HubMenu from "../../hubweb/components/HubMenu.jsx";
import Menu from "./menu.jsx";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { removeSystemMessage } from "../actions/systemMessage.js";
import { scssVariables } from "../util/config.jsx";

const mapStateToProps = state => {
    return {
        isChainLogin: state.authentication.isChainLogin || false,
        isHubLogin: state.authentication.isHubLogin || false,
        isDominosLogin: state.authentication.isDominosLogin || false,
        modal: state.modal.modal,
        dropDown: state.modal.dropDown,
        deviceType: state.view.deviceType,
        productImage: state.productImage,
        messages: state.systemMessage.messages,
    };
};
const mapDispatchToProps = {
    setModal,
    setDropDown,
    removeSystemMessage,
};

class ContentWrapper extends React.Component{
    constructor(props){
        super(props);

        this.closeModal = this.closeModal.bind(this);
        this.closeDropDown = this.closeDropDown.bind(this);
    }

    closeModal() {
        this.props.setModal(null);
    }
    closeDropDown() {
        this.props.setDropDown(null);
    }
    
    render(){
        const {
            children,
            deviceType,
            modal,
            dropDown,
            extraStyles,
            height,
            paddingRight,
            isChainLogin,
            isHubLogin,
            isDominosLogin,
        }  = this.props;
        const padding = scssVariables[`${deviceType}ContentPadding`];
        const usePadding = padding!=="0px";
        const style = {
            paddingLeft: usePadding ? padding : undefined,
            paddingRight: (usePadding && paddingRight) ? padding : undefined,
            paddingBottom: usePadding ? padding : undefined,
            paddingTop: usePadding ? padding : undefined,
            height: `${height}px`,
            overflowY: "auto",
            ...(extraStyles || {})
        };

        return (
            <React.Fragment>
                {isHubLogin ? <HubMenu /> : isDominosLogin ? <DominosMenu /> : isChainLogin ? <ChainMenu /> : <Menu />}
                {modal && (
                    <React.Fragment>
                        <div className="dim-screen" style={{zIndex:3}} onClick={this.closeModal}/>
                        {modal}
                    </React.Fragment>
                )}
                {dropDown.map( (item, index) => (
                    <React.Fragment key={index}>
                        <div className="dim-screen" style={{zIndex:3}} onClick={this.closeDropDown}/>
                        {item}
                    </React.Fragment>
                ))}
                <div className="content-backgorund" style={style}>
                    {children}
                </div>
            </React.Fragment>
        );
    }
}
ContentWrapper.propTypes = {
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    removeSystemMessage: PropTypes.func.isRequired,
    isChainLogin: PropTypes.bool.isRequired,
    isHubLogin: PropTypes.bool.isRequired,
    isDominosLogin: PropTypes.bool.isRequired,
    view: PropTypes.object,
    children: PropTypes.node,
    deviceType: PropTypes.string,
    height: PropTypes.number,
    paddingRight: PropTypes.bool,
    extraStyles: PropTypes.object,
    modal: PropTypes.node,
    dropDown: PropTypes.node,
};

ContentWrapper.defaultProps = {
    paddingRight: true
};

export default connect(mapStateToProps, mapDispatchToProps)(ContentWrapper);